import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import { EnumUserLocale } from 'modules/common/types/locale'
import { ListItemsContainer } from '../../_ui/ListItemsContainer/ListItemsContainer'
import { EmailTouchpointListItem } from './EmailTouchpointListItem/EmailTouchpointListItem'
import { PhoneTouchpointListItem } from './PhoneTouchpointListItem/PhoneTouchpointListItem'
import { WhatsAppTouchpointListItem } from './WhatsAppTouchpointListItem/WhatsAppTouchpointListItem'

interface Props {
  emailSupport?: string
  phoneSupport?: string
  whatsAppSupportNumber?: string
}

export const SupportModalTouchpoints = ({
  emailSupport,
  phoneSupport,
  whatsAppSupportNumber,
}: Props) => {
  const userLocale = useUserLocale()
  const isItaly = userLocale === EnumUserLocale.IT

  return (
    <ListItemsContainer>
      {!!phoneSupport && isItaly && (
        <PhoneTouchpointListItem phoneSupport={phoneSupport} />
      )}
      {!!emailSupport && isItaly && (
        <EmailTouchpointListItem emailSupport={emailSupport} />
      )}
      {!!whatsAppSupportNumber && (
        <WhatsAppTouchpointListItem
          whatsAppSupportNumber={whatsAppSupportNumber}
        />
      )}
    </ListItemsContainer>
  )
}
